import RichText from '~/components/ui/RichText.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import { generateTwicPicBackgroundImageSet } from '~/composables/useResponsiveBackground';
import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'ItemImageTextStandard',
  components: {
    RichText: RichText,
    AzImg: AzImg
  },
  props: {
    image: Object,
    text: Object,
    title: [Object, String],
    classes: {
      type: Object,
      default: function _default() {}
    },
    link: [Object, String],
    isHomePage: Boolean,
    displayOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useNuxt2App = useNuxt2App(),
      $config = _useNuxt2App.$config;
    var customRenderer = function customRenderer() {
      return {
        renderNode: {
          paragraph: function paragraph(node, next) {
            return "<h4>".concat(next(node.content), "</h4>");
          }
        },
        renderMark: {}
      };
    };
    var imgUrl = computed(function () {
      var _props$image, _props$image$fields, _props$image$fields$f;
      return (_props$image = props.image) === null || _props$image === void 0 ? void 0 : (_props$image$fields = _props$image.fields) === null || _props$image$fields === void 0 ? void 0 : (_props$image$fields$f = _props$image$fields.file) === null || _props$image$fields$f === void 0 ? void 0 : _props$image$fields$f.url;
    });
    var backgroundImage = computed(function () {
      if (props.isHomePage) {
        var _props$image2, _props$image2$fields, _props$image2$fields$;
        return generateTwicPicBackgroundImageSet($config.public.cloudinaryDomain, (_props$image2 = props.image) === null || _props$image2 === void 0 ? void 0 : (_props$image2$fields = _props$image2.fields) === null || _props$image2$fields === void 0 ? void 0 : (_props$image2$fields$ = _props$image2$fields.file) === null || _props$image2$fields$ === void 0 ? void 0 : _props$image2$fields$.url, 220);
      }
    });
    var computedClasses = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      customRenderer: customRenderer,
      computedClasses: computedClasses,
      imgUrl: imgUrl,
      backgroundImage: backgroundImage
    };
  }
});